"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRefreshTokenDto = instanceOfRefreshTokenDto;
exports.RefreshTokenDtoFromJSON = RefreshTokenDtoFromJSON;
exports.RefreshTokenDtoFromJSONTyped = RefreshTokenDtoFromJSONTyped;
exports.RefreshTokenDtoToJSON = RefreshTokenDtoToJSON;
exports.RefreshTokenDtoToJSONTyped = RefreshTokenDtoToJSONTyped;
/**
 * Check if a given object implements the RefreshTokenDto interface.
 */
function instanceOfRefreshTokenDto(value) {
    if (!('refreshToken' in value) || value['refreshToken'] === undefined)
        return false;
    return true;
}
function RefreshTokenDtoFromJSON(json) {
    return RefreshTokenDtoFromJSONTyped(json, false);
}
function RefreshTokenDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'refreshToken': json['refreshToken'],
        'deviceFingerprint': json['deviceFingerprint'] == null ? undefined : json['deviceFingerprint'],
    };
}
function RefreshTokenDtoToJSON(json) {
    return RefreshTokenDtoToJSONTyped(json, false);
}
function RefreshTokenDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'refreshToken': value['refreshToken'],
        'deviceFingerprint': value['deviceFingerprint'],
    };
}
